import request from '@/utils/request'

// 批量导入 上传文件
export const ImportUploadFileApI = (data) => request.post('/users/import_students/', data)

// 批量导出学生
export const BatchExportStudentAPI = () => request.get('/users/get_excel_student/')

// 获取学生信息
export const GetStudentAPI = (data) => request.get('/users/students/', { params: data })

// 删除学生
export const DelStudentAPI = (id) => request.delete(`/users/students/${id}/`)

// 删除全部学生
export const DelAllStudentAPI = () => request.delete('/users/del_all_student/')

// 添加学生
export const AddStudentAPI = (data) => request.post('/users/students/', data)

// 编辑学生
export const PutStudentAPI = (data) => request.put(`/users/students/${data.id}/`, data)

// 获取学生详情
export const GetStuDetailAPI = (id) => request.get(`/users/students/${id}/`)

// 修改学生加分管理
export const PutStuScoreAPI = (data) => request.post('/users/student_add_score/', data)

// 获取学生加分管理
export const GetStuScoreAPI = () => request.get('/users/student_add_score/')

// 批量删除毕业生信息列表
export const BatchDel = (data) => request.delete(`/users/delete_all_graduation/`, { data: { ids: data }})
